import type { ContextProvider } from './types';
import { consumeAsyncValue } from './async-value';

/**
 * 动态上下文管理器
 * 支持全局静态属性与动态 Provider 混合求值（如动态商户、多租户上下文）
 */
export class ContextManager {
  private staticContext: Record<string, any> = {};
  private providers = new Map<string, ContextProvider>();

  public setStaticContext(ctx: Record<string, any>): void {
    this.staticContext = { ...this.staticContext, ...ctx };
  }

  public registerProvider(name: string, provider: ContextProvider): void {
    this.providers.set(name, provider);
  }

  public unregisterProvider(name: string): void {
    this.providers.delete(name);
  }

  /**
   * 聚合所有静态上下文与动态 Provider 返回的键值对
   */
  public resolveContext(): Record<string, any> {
    const result: Record<string, any> = { ...this.staticContext };

    for (const [, provider] of this.providers) {
      try {
        const val = provider();
        if (consumeAsyncValue(val)) continue;
        if (val && typeof val === 'object') {
          Object.assign(result, val);
        }
      } catch {
        // 单个 Provider 异常不影响其他 Provider
      }
    }

    return result;
  }
}
